var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoUserGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.75C2.75 4.50736 3.75736 3.5 5 3.5H19C20.2426 3.5 21.25 4.50736 21.25 5.75V7.51785C21.25 7.93206 20.9142 8.26785 20.5 8.26785C20.0858 8.26785 19.75 7.93206 19.75 7.51785V5.75C19.75 5.33579 19.4142 5 19 5H5C4.58579 5 4.25 5.33579 4.25 5.75V7.51785C4.25 7.93206 3.91421 8.26785 3.5 8.26785C3.08579 8.26785 2.75 7.93206 2.75 7.51785V5.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.8216 12.1602C15.9915 11.711 16.0845 11.224 16.0845 10.7153C16.0845 10.3823 16.0446 10.0586 15.9694 9.74877C16.3784 9.18618 17.0418 8.82043 17.7905 8.82043C19.0332 8.82043 20.0405 9.82779 20.0405 11.0704C20.0405 12.3131 19.0332 13.3204 17.7905 13.3204C16.9432 13.3204 16.2053 12.8521 15.8216 12.1602Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3398 18.5704C18.4056 18.2968 18.4405 18.0111 18.4405 17.7172C18.4405 16.2225 17.7175 14.8967 16.6021 14.0704H19.3749C20.8246 14.0704 21.9999 15.2457 21.9999 16.6954C21.9999 17.731 21.1604 18.5704 20.1249 18.5704H18.3398Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.39628 14.0704C6.28089 14.8967 5.55786 16.2225 5.55786 17.7172C5.55786 18.0111 5.59275 18.2968 5.65861 18.5704H3.875C2.83947 18.5704 2 17.731 2 16.6954C2 15.2457 3.17525 14.0704 4.625 14.0704H7.39628Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.03075 9.74901C7.9556 10.0588 7.91577 10.3824 7.91577 10.7153C7.91577 11.2239 8.00873 11.7108 8.17859 12.1599C7.79486 12.852 7.05687 13.3204 6.20947 13.3204C4.96683 13.3204 3.95947 12.3131 3.95947 11.0704C3.95947 9.82779 4.96683 8.82043 6.20947 8.82043C6.95834 8.82043 7.62177 9.18629 8.03075 9.74901Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 8.32617C10.5878 8.32617 9.44415 9.46979 9.44415 10.8805C9.44415 12.2912 10.5878 13.4349 11.9985 13.4349C13.4092 13.4349 14.5528 12.2912 14.5528 10.8805C14.5528 9.46979 13.4092 8.32617 11.9985 8.32617Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0934 14.6406C8.43358 14.6406 7.088 15.9862 7.088 17.6461C7.088 18.8077 8.02967 19.7493 9.19126 19.7493H14.8074C15.969 19.7493 16.9106 18.8077 16.9106 17.6461C16.9106 15.9862 15.5651 14.6406 13.9052 14.6406H10.0934Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoUserGroup);
export default __webpack_public_path__ + "static/media/DuoUserGroup.72e0308f4dd72f592ecab9f3b63897be.svg";
export { ForwardRef as ReactComponent };